import { z } from "zod/v4";

// =============================================================================
// Structural type for discount tier-like objects
// =============================================================================

type DiscountTierLike = {
  minimumUnits: number;
  maximumUnits: number | null;
};

// =============================================================================
// Refinement Functions (exported for testing/selective use)
// =============================================================================

export const discountTierRefinements = {
  minLessThanOrEqualToMax: <T extends DiscountTierLike>(tier: T) =>
    tier.maximumUnits === null || tier.minimumUnits <= tier.maximumUnits,
};

export const discountTierRefinementMessages = {
  minLessThanOrEqualToMax:
    "Minimum units must be less than or equal to maximum units",
};

// =============================================================================
// Helper to apply all standard discount tier refinements
// =============================================================================

export function applyDiscountTierRefinements<
  S extends z.ZodObject<z.ZodRawShape>,
>(schema: S) {
  return schema.refine(
    (tier) => {
      const t = tier as DiscountTierLike;
      return t.maximumUnits === null || t.minimumUnits <= t.maximumUnits;
    },
    { message: discountTierRefinementMessages.minLessThanOrEqualToMax }
  );
}
